import { baseApi } from "@/redux/api/baseApi";

const rawFootageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRawFootage: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/raw-footage/${orderId}/${videoId}`,
        method: "GET",
      }),
      providesTags: ["rawFootage"],
    }),

    uploadRawFootage: builder.mutation({
      query: (payload) => ({
        url: `/raw-footage/${payload.orderId}/${payload.videoId}`,
        method: "POST",
        body: payload.data,
      }),
      invalidatesTags: ["rawFootage", "OrderDetails"],
    }),

    uploadRevisedRawFootage: builder.mutation({
      query: (payload) => ({
        url: `/raw-footage/upload-new-version/${payload.orderId}/${payload.videoId}`,
        method: "POST",
        body: payload.data,
      }),
      invalidatesTags: ["rawFootage", "OrderDetails"],
    }),
    uploadAdditionalFile: builder.mutation({
      query: (payload) => ({
        url: `/raw-footage/upload-additional-file/${payload.orderId}/${payload.videoId}`,
        method: "POST",
        body: payload.data,
      }),
      invalidatesTags: ["rawFootage", "OrderDetails"],
    }),

    requestRawFootageTimeLineExtension: builder.mutation({
      query: ({ orderId, videoId, body }) => ({
        url: `/raw-footage/request-an-extension/${orderId}/${videoId}`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["rawFootage"],
    }),
  }),
});

export const {
  useGetRawFootageQuery,
  useUploadRawFootageMutation,
  useUploadRevisedRawFootageMutation,
  useUploadAdditionalFileMutation,
  useRequestRawFootageTimeLineExtensionMutation,
} = rawFootageApi;
